module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mt-checkbox",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label) + "\n    "), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": _vm.id,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('input', $event.target.checked)
      }
    }
  }), _vm._v(" "), _c('span')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8317f640","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/EditorCheckbox.vue
// module id = 1715
// module chunks = 1